export default class ApiError extends Error {
  constructor(message, statusCode) {
    super(message);
    this.statusCode = statusCode;
  }
}

// Normalizes the various shapes the backend uses for validation errors into
// { fieldErrors: { [fieldName]: message }, generalMessage: string }
export const parseApiError = (error, fallbackMessage = "Something went wrong. Please try again.") => {
  const data = error?.response?.data;
  const fieldErrors = {};
  let generalMessage = fallbackMessage;

  const messages = data?.error?.message;

  if (Array.isArray(messages) && messages.length > 0) {
    messages.forEach((item) => {
      if (item?.field && item?.message) {
        fieldErrors[item.field] = item.message;
      }
    });
    generalMessage = Object.keys(fieldErrors).length
      ? "Please fix the highlighted fields."
      : messages.map((item) => item?.message).filter(Boolean).join("\n") || fallbackMessage;
  } else if (typeof messages === "string" && messages) {
    generalMessage = messages;
  } else if (typeof data?.message === "string" && data.message) {
    generalMessage = data.message;
  } else if (typeof data?.error === "string" && data.error) {
    generalMessage = data.error;
  }

  return { fieldErrors, generalMessage };
};
